/* eslint-disable */
import dayjs from 'dayjs';
import _ from "lodash/fp";
import React, { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import advertisementDetailsLabel from "../../application_management/labels/advertisement_details_en.json";
import ModuleHide from "../../common/components/ModuleHide";
import { BOOLEAN_OPTION, EMPLOYMENT_TYPE, FULLTIME_OPTION, GROUP_OPTION } from '../../common/constants/dropdownOptions';
import { devNagariRegex, expLetterNumberRegex, numberWithDecimal, numberWithDecimalandComma } from '../../common/constants/regex';
import commonENLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import { dateDifferece, fromUTCDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import { getLookOptionsForADropdown } from "../../helpers/LookupOptionHelper";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/advertisementTable.css";
import '../../styles/profile.css';
import { addExperienceList, clearEditExperienceInfo, editExperienceInfo, getAllJobDesignationDetails, getExperienceInformation, getFormattedLastUpdatedDate, saveExperienceList, setProfileCreationDropdown } from '../actions/profileAction';
import { experienceInfoReqDTO } from "../constants/experienceInfoReqDTO";
import common from "../labels/common_en.json";
import profileexperienceinofo from "../labels/experience_information_en.json";
import numberformat from '../labels/serial_nos_en.json';
import ExperienceTabTable from './ExperienceTabTable';
import { disableAllSaveAfterSubmit} from "../actions/profileAction";



const ExperienceInformation = (props) => {

  const [experienceInfoState, setExperienceInfoState] = useState(experienceInfoReqDTO);
  let [showModal, setShowModal] = useState(false);
  const [isChangeFrom, setIsChangeFrom] = useState(false);
  const [isChangeTo, setIsChangeTo] = useState(false);
  const [reloadItem, setReloadItem] = useState(0);
  const [designationId, setDesignationId] = useState('');
  const [designationName, setDesignationName] = useState('');
  const [officeName, setOfficeName] = useState('');
  const [payScale, setPayScale] = useState('');
  const [gradePay, setGradePay] = useState('');
  const [basicPay, setBasicPay] = useState('');
  const [monthlyGrossSalary, setMonthlyGrossSalary] = useState('');
  const [employeeType, setEmployeeType] = useState('');
  useEffect(() => {
    setReloadItem(reloadItem);
  }, [reloadItem]);
  useEffect(() => {
    setOfficeName('');
    setPayScale('');
    setGradePay('');
    setBasicPay('');
    setMonthlyGrossSalary('');
    //setDesignationName("");
    setDesignationId("")
    experienceInfoState && experienceInfoState.designation && setDesignationName(experienceInfoState.designation);
    experienceInfoState && experienceInfoState.designationId && setDesignationId(experienceInfoState.designationId);
    experienceInfoState && experienceInfoState.officeName && setOfficeName(experienceInfoState.officeName);
    experienceInfoState && experienceInfoState.payScale && setPayScale(experienceInfoState.payScale);
    experienceInfoState && experienceInfoState.gradePay && setGradePay(experienceInfoState.gradePay);
    experienceInfoState && experienceInfoState.basicPay && setBasicPay(experienceInfoState.basicPay);
    experienceInfoState && experienceInfoState.monthlyGrossSalary && setMonthlyGrossSalary(experienceInfoState.monthlyGrossSalary);
    setReloadItem(!reloadItem);
  }, [experienceInfoState]);


  const handleExperienceInfoState = (evt) => {
    setReloadItem(!reloadItem);
    setIsChangeTo(false);
    setIsChangeFrom(false);
    const value = evt.target.value;
    const name = evt.target.name;
    let employmentFrom = '';
    let employmentTo = '';
    if ((name === "designationId")) {
      let designationName = jobDesignationLabel(value)
      setDesignationName(designationName);

      setExperienceInfoState({
        ...experienceInfoState,
        [designationName]: designationName,
      });
    }

    if ((name === "jobNatureLookupId") || (name === "officeName") || (name === "postNameLookupId") || (name === "postNameOther") || (name === "isOfficeGovOwned") || (name === "designationId") || (name === "designationName") || (name === "isGazettedPost") || (name === "apointmentNatureLookupId") || (name === "apointmentNatureLookupId") || (name === "appointmentLetterNo") || (name === "payScale") || (name === "gradePay") || (name === "basicPay") || (name === "monthlyGrossSalary")) {
      setExperienceInfoState({
        ...experienceInfoState,
        [evt.target.name]: value,
      });
    }

    if ((name !== "jobNatureLookupId") && (name !== "officeName") && (name !== "postNameLookupId") && (name !== "postNameOther") && (name !== "isOfficeGovOwned") && (name !== "designationId") && (name !== "designationName") && (name !== "isGazettedPost") && (name !== "apointmentNatureLookupId") && (name !== "apointmentNatureLookupId") && (name !== "appointmentLetterNo") && (name !== "payScale") && (name !== "gradePay") && (name !== "basicPay") && (name !== "monthlyGrossSalary")) {
      if (value === "2" && name === "typeEmploymentLookupId") {
        employmentFrom = watch("employmentFrom") ? watch("employmentFrom") : dayjs(experienceInfoState.employmentFrom).toDate();
        employmentTo = new Date();
      }
      else {
        employmentFrom = watch("employmentFrom") ? watch("employmentFrom") : dayjs(experienceInfoState.employmentFrom).toDate();
        employmentTo = watch("employmentTo") ? watch("employmentTo") : dayjs(experienceInfoState.employmentTo).toDate();
      }

      let expYears = 0;
      let expMonths = 0;
      let expDays = 0;
      if (employmentFrom) {
        let difference = dateDifferece(employmentFrom, employmentTo);
        if (difference.firstDateWasLater) {
          expYears = 0;
          expMonths = 0;
          expDays = 0;
          toastr.error(profileexperienceinofo.TO_DATE_SHOULD_BE_GREATER_THAN_FROM_DATE);
        } else {
          expYears = difference.years;
          expMonths = difference.months;
          expDays = difference.days;
        }
      }

      setExperienceInfoState({
        ...experienceInfoState,
        expYears: !(isNaN(expYears)) ? expYears : 0,
        expMonths: !(isNaN(expMonths)) ? expMonths : 0,
        expDays: !(isNaN(expDays)) ? expDays : 0,
        [evt.target.name]: value,
      });
    }
    if (evt.target.name === "institutionLookupId") {
      setExperienceInfoState({
        ...experienceInfoState,
        ["institutionLookupId"]: value,
      });
    }
    // if (evt.target.name === "isBpscSelection") {
    //   setExperienceInfoState({
    //     ...experienceInfoState,
    //     ["isBpscSelection"]: value,
    //     ["postNameLookupId"]: ''
    //   });
    //   setValue("postNameLookupId", '');
    // }
    if (evt.target.name === "isGazettedPost") {
      setExperienceInfoState({
        ...experienceInfoState,
        ["isGazettedPost"]: value,
        ["typeGroupLookupId"]: ''
      });
      setValue("typeGroupLookupId", '');
    }
    if (evt.target.name === "apointmentNatureLookupId") {
      setExperienceInfoState({
        ...experienceInfoState,
        ["apointmentNatureLookupId"]: value,
        ["fullTimeLookupId"]: '',
        ["appointmentLetterNo"]: '',
        ["appointmentLetterDate"]: ''
      });

      setValue("fullTimeLookupId", '')
      setValue("appointmentLetterNo", '')
      setValue("appointmentLetterDate", '')
    }
    setReloadItem(!reloadItem);
  }

  const { register, control, watch, errors, handleSubmit, reset, setValue } = useForm({
    mode: "onChange"
  });

  useEffect(() => {
    setReloadItem(!reloadItem);
  }, [experienceInfoState]);

  const isBpscSelectionflg = watch("isBpscSelection");
  const isGazettedPostflg = watch("isGazettedPost");
  const istypeEmploymentflg = watch("typeEmploymentLookupId");
  const employeeTypeLookupId = watch("employeeTypeLookupId");
  const apointmentNatureflag = watch("apointmentNatureLookupId");
  const dispatch = useDispatch();
  const [actionType, setActionType] = useState("add");
  const employmentFromSelected = watch("employmentFrom");
  const isDisableAllTabSave = useSelector(state => state.profile.isDisableAllTabSave);
  const [designationNameFlg, setDesignationNameFlg] = useState("");
  

 useEffect(() => {
   if (!props.profileStatus) {
     dispatch(disableAllSaveAfterSubmit(false));
   } else if (
     props.enableEditProfileWithLock?.editProfileWithLock == "1"
   ) {
     dispatch(disableAllSaveAfterSubmit(false));
   } else {
     dispatch(disableAllSaveAfterSubmit(true));
   }
 }, [dispatch, props.profileStatus, props.enableEditProfileWithLock?.editProfileWithLock]);
 
  
  useEffect(() => {
    dispatch(getExperienceInformation());
    dispatch(getAllJobDesignationDetails())
    dispatch(setProfileCreationDropdown());
  }, []);

  

  const { moduleList } = useSelector(state => state.loginReducer, shallowEqual);
  const [arraymModule, setarraymModule] = useState({})

  useEffect(() => {
    setarraymModule(moduleList && moduleList.filter((ele) => ele.moduleName === "EXPERIENCE_INFO")[0])
  }, [moduleList])

  let { experiencesList, profileCreationAllLookupData, flagExperienceEdit, experienceToBeEdited, experienceTableList, getJobDesignationList, authenticationDataObj } = useSelector(state => state.profile, shallowEqual);


  useEffect(() => {
    setExperienceInfoState({
      isSubmittable: false,
      typeEmploymentLookupId: experiencesList.typeEmploymentLookupId,
      employeeTypeLookupId: experiencesList.employeeTypeLookupId,
      // isBpscSelection: experiencesList.isBpscSelection,
      institutionLookupId: experiencesList.institutionLookupId,
      postNameLookupId: experiencesList.postNameLookupId,
      postNameOther: experiencesList.postNameOther,
      officeName: experiencesList.officeName,
      isOfficeGovOwned: experiencesList.isOfficeGovOwned,
      designation: experiencesList.designation,
      designationId: experiencesList.designationId,
      jobNatureLookupId: experiencesList.jobNatureLookupId,
      isGazettedPost: experiencesList.isGazettedPost,
      typeGroupLookupId: experiencesList.typeGroupLookupId,
      apointmentNatureLookupId: experiencesList.apointmentNatureLookupId,
      fullTimeLookupId: experiencesList.fullTimeLookupId,
      appointmentLetterNo: experiencesList.appointmentLetterNo,
      appointmentLetterDate: experiencesList.appointmentLetterDate,
      payScale: experiencesList.payScale,
      gradePay: experiencesList.gradePay,
      basicPay: experiencesList.basicPay,
      monthlyGrossSalary: experiencesList.monthlyGrossSalary,
      employmentFrom: experiencesList.employmentFrom,
      employmentTo: experiencesList.employmentTo,
      expYears: experiencesList.expYears,
      expMonths: experiencesList.expMonths,
      expDays: experiencesList.expDays,
      isDeleted: 0,
      remarks: null,
      isExperience: isExperience == 'Yes' ? true : false,
    });

    setReloadItem(!reloadItem);
    let displayIsExperience = "No";

    if (experiencesList && experiencesList.length > 0) {
      displayIsExperience = experiencesList[0].isExperience ? "Yes" : "No";
    }

    setIsExperience(displayIsExperience);
    setValue('isExperience', displayIsExperience);
    setReloadItem(!reloadItem);
  }, [experiencesList]);

  useEffect(() => {
    setExperienceInfoState(experienceToBeEdited);
    setReloadItem(!reloadItem);
    setValue('postNameOther', experienceToBeEdited ? experienceToBeEdited.postNameOther : "");
    if (experienceToBeEdited && experienceToBeEdited.appointmentLetterNo) {
      setValue('appointmentLetterNo', experienceToBeEdited.appointmentLetterNo);
      setValue('apointmentNatureLookupId', experienceToBeEdited.apointmentNatureLookupId);
      setValue('appointmentLetterDate', experienceToBeEdited.appointmentLetterDate);
    }
    setReloadItem(!reloadItem);

    if (experienceToBeEdited && (experienceToBeEdited.designationId === 0)) {
      setDesignationNameFlg(experienceToBeEdited.designationId);
    }

  }, [experienceToBeEdited]);

  useEffect(() => {
    setExperienceInfoState({
      typeEmploymentLookupId: experiencesList && experiencesList.typeEmploymentLookupId,
      employeeTypeLookupId: experiencesList && experiencesList.employeeTypeLookupId,
      // isBpscSelection: experiencesList && experiencesList.isBpscSelection,
      institutionLookupId: experiencesList && experiencesList.institutionLookupId,
      jobNatureLookupId: experiencesList && experiencesList.jobNatureLookupId,
      fullTimeLookupId: experiencesList && experiencesList.fullTimeLookupId,
      isOfficeGovOwned: experiencesList && experiencesList.isOfficeGovOwned,
      isGazettedPost: experiencesList && experiencesList.isGazettedPost,
      typeGroupLookupId: experiencesList && experiencesList.typeGroupLookupId,
      apointmentNatureLookupId: experiencesList && experiencesList.apointmentNatureLookupId,
      employmentFrom: experiencesList && experiencesList.employmentFrom,
      employmentTo: experiencesList && experiencesList.employmentTo
    });
    setReloadItem(!reloadItem);
  }, []);

  const handleFromToDateSelection = (fromdate, todate) => {
    if (!todate && !experienceInfoState.employmentTo) {
      todate = experienceInfoState.employmentTo;
    }
    else if (!todate && experienceInfoState.employmentTo) {
      todate = experienceInfoState.employmentTo;
    }

    if (!fromdate && !experienceInfoState.employmentFrom) {
      fromdate = new Date();
    }
    else if (!fromdate && experienceInfoState.employmentFrom) {
      fromdate = experienceInfoState.employmentFrom;
    }

    let difference = dateDifferece(fromdate, todate);
    let expYears = 0;
    let expMonths = 0;
    let expDays = 0;

    if (difference.firstDateWasLater) {
      expYears = 0;
      expMonths = 0;
      expDays = 0;
      toastr.error(profileexperienceinofo.TO_DATE_SHOULD_BE_GREATER_THAN_FROM_DATE);
    } else {
      expYears = difference.years;
      expMonths = difference.months;
      expDays = difference.days;
    }



    setExperienceInfoState({
      ...experienceInfoState,
      employmentFrom: fromdate,
      employmentTo: todate,
      expYears: !(isNaN(expYears)) ? expYears : 0,
      expMonths: !(isNaN(expMonths)) ? expMonths : 0,
      expDays: !(isNaN(expDays)) ? expDays : 0
    })
    setReloadItem(!reloadItem);
  }

  const modalConfirm = () => {
    dispatch(saveExperienceList(experiencesList, isExperience));
    dispatch(clearEditExperienceInfo(experienceInfoReqDTO));

    if (isExperience === "Yes" && experiencesList.length === 0) {
      setValue("isExperience", "No");
      setIsExperience("No");
    }
    // clear row when action type is not set to add or edit
    setExperienceInfoState(experienceInfoReqDTO);
    setReloadItem(!reloadItem);
    reset();
    setReloadItem(!reloadItem);
    setShowModal(false);
    
  }

  const jobDesignationLabel = (value) => {
    const foundItem = getJobDesignationList && getJobDesignationList.length > 0 && getJobDesignationList.find(item => item.id == value);
    return foundItem ? foundItem.label : "";
  };

  const handleExperienceInfoSubmit = (e) => {
    e = experienceInfoState;
    let presentAddedError = e.typeEmploymentLookupId == 2 ? profileexperienceinofo.PRESENT_EXPERIENCE_IS_ALREADY_ADDED : profileexperienceinofo.DATES_ARE_OVERLAPPING_PLEASE_CHECK
    for (let element of experienceTableList) {
      if (actionType === "edit" && experienceToBeEdited.id == element.id) {
        setDesignationNameFlg("")
        continue;
      }
      if (e.employmentTo == null && ((element.employmentTo == "" || element.employmentTo == undefined))) {
        toastr.error(presentAddedError)
        return;
      }
      if (e.employmentTo == null && !(dayjs(e.employmentFrom).isAfter(element.employmentTo))) {
        toastr.error(profileexperienceinofo.FROM_DATE_GREATER_THAN_PREV_EXP_TO_DATE_1)
        return;
      }
      if ((element.employmentTo == "" || element.employmentTo == undefined) && !(dayjs(element.employmentFrom).isAfter(e.employmentTo))) {
        toastr.error(presentAddedError)
        return;
      }
      if (!(dayjs(e.employmentTo).isBefore(element.employmentFrom) || dayjs(e.employmentFrom).isAfter(element.employmentTo))) {
        toastr.error(profileexperienceinofo.FROM_DATE_GREATER_THAN_PREV_EXP_TO_DATE_2)
        return;
      }
    }

    experienceInfoState.typeEmploymentLookupId = e.typeEmploymentLookupId;
    // experienceInfoState.isBpscSelection = e.isBpscSelection;
    experienceInfoState.institutionLookupId = e.institutionLookupId;
    experienceInfoState.jobNatureLookupId = e.jobNatureLookupId;
    experienceInfoState.postNameLookupId = e.postNameLookupId;
    experienceInfoState.postNameOther = e.postNameOther;
    experienceInfoState.officeName = e.officeName;
    experienceInfoState.isOfficeGovOwned = e.isOfficeGovOwned;
    experienceInfoState.isGazettedPost = e.isGazettedPost;
    experienceInfoState.typeGroupLookupId = e.typeGroupLookupId;
    experienceInfoState.apointmentNatureLookupId = e.apointmentNatureLookupId;
    experienceInfoState.fullTimeLookupId = e.fullTimeLookupId;
    experienceInfoState.designation = jobDesignationLabel(e.designationId);
    experienceInfoState.designationId = e.designationId;
    experienceInfoState.payScale = e.payScale;
    experienceInfoState.monthlyGrossSalary = e.monthlyGrossSalary;
    experienceInfoState.gradePay = e.gradePay;
    experienceInfoState.employmentFrom = e.employmentFrom;
    experienceInfoState.employmentTo = e.employmentTo;
    experienceInfoState.basicPay = e.basicPay;
    experienceInfoState.employeeTypeLookupId = e.employeeTypeLookupId;
    experienceInfoState.appointmentLetterNo = e.appointmentLetterNo;
    experienceInfoState.appointmentLetterDate = e.appointmentLetterDate;

    /** OAS-645 */
    experienceInfoState.isExperience = isExperience == 'Yes' ? true : false;

    if (actionType === "add") {
      let experienceInfoToBeAdded = { ...experienceInfoState };
      if (!experienceInfoToBeAdded.designationId) {
        toastr.warning("Select a designation");
        return;
      }
      dispatch(addExperienceList(experienceInfoToBeAdded, experiencesList));
    }
    if (actionType === "edit") {
      experienceInfoState.id = experienceToBeEdited.id;
      dispatch(editExperienceInfo(experienceInfoState, experiencesList));
    }

    /** Clear the local row state once experienceInfo is added or updated*/
    setExperienceInfoState(experienceInfoReqDTO);
    setReloadItem(!reloadItem);
    reset();
  }
  const [isExperience, setIsExperience] = useState("No")
  const jobNatureList = getLookOptionsForADropdown("job_nature", profileCreationAllLookupData);
  const postList = getLookOptionsForADropdown("post_name", profileCreationAllLookupData);
  const employeeTypeList = getLookOptionsForADropdown("employee_type", profileCreationAllLookupData);
  const appointmentNatureList = getLookOptionsForADropdown("appointment_nature", profileCreationAllLookupData);
  const medicalCollegesList = getLookOptionsForADropdown("job_institution", profileCreationAllLookupData);

  const saveExpInfo = () => {
    dispatch(clearEditExperienceInfo(experienceInfoReqDTO))
    dispatch(saveExperienceList(experiencesList, isExperience));
  }


  const allUpdatedDates = [...experiencesList];
  const latestDate = allUpdatedDates.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
  const latestUpdatedTime = latestDate?.updatedAt?.split("T")[0]
  const formattedUpdatedDate = new Date(latestUpdatedTime).toLocaleDateString("en-GB");
  const [activeIntershipIndex, setActiveIntershipIndex] = useState(null);


  //    const experienceInfoList =
  //   props.enableEditProfileWithLock?.editProfileWithLock == "1"
  //     ? props.enableEditProfileWithLock?.ExperienceInfo?.split(",")
  //     : [];
  // const canSave = experienceInfoList.includes("C");
  // const canEdit = experienceInfoList.includes("U");
  // const canDelete = experienceInfoList.includes("D");


  return arraymModule && arraymModule.isEnabled == false ? < ModuleHide details={arraymModule} /> :
    (
      <div className="p-4 f12">
        <div className="p-1 bg-blue date_flex">
          <h5 className="text-white">
            <img src="/icons/user-detail.png" /> &nbsp;{profileexperienceinofo.EXPERIENCE_INFO} : {commonHILabels.EXPERIENCE_INFORMATION.EXPERIENCE_INFO}
          </h5>
          <h5 className="text-white last_updated_date">
            {profileexperienceinofo.LAST_UPDATED_ON}{" "}
            {getFormattedLastUpdatedDate(formattedUpdatedDate)}
          </h5>
        </div>
        <div className="row mt-2">
          <div className="pt-4 col-md-12">
            <h5 className="bottom-dotted-line align-left p-1" >
              5. {profileexperienceinofo.EXPERIENCE_DETAILS}: {commonHILabels.EXPERIENCE_INFORMATION.EXPERIENCE_DETAILS}
            </h5>

          </div>
        </div>
        <div className="row experienceTabHeading mt-1  d-flex" >

          <div className="col-auto">
            <span className="ms-1 text-start mb-0">{profileexperienceinofo.ARE_YOU_HAVING_EXPERIENCE} {commonHILabels.EXPERIENCE_INFORMATION.ARE_YOU_HAVING_EXPERIENCE}</span>
          </div>

          <div className="col-auto form-check">
            <div className="row  d-flex">
              <div className="col-auto form-check">
                <label className="form-check-label">
                  <input
                    type="radio"
                    checked={(isExperience === "Yes" ? true : false)}
                    onChange={(e) => { setIsExperience(e.target.value) }}
                    className="form-check-input RadioText"
                    value="Yes"
                    name="isExperience"
                    ref={register({ required: true })}
                  />&nbsp;{profileexperienceinofo.YES}</label>
              </div>
              <div className="col-auto form-check">
                <label className="form-check-label">
                  <input
                    type="radio"
                    checked={(isExperience === "No" ? true : false)}
                    onChange={(e) => { setIsExperience(e.target.value); setExperienceInfoState(experienceInfoReqDTO); reset(); }}
                    name="isExperience"
                    value="No"
                    className="form-check-input me-1"
                    ref={register({ required: true })} />{profileexperienceinofo.NO}</label>
              </div>
              {/* <div className="col-auto">
            <span className="digilockerText"><img src="/icons/tickIcon.png" width="20" height="20" /> Digilocker verified</span>
            </div> */}
            </div>


          </div>

        </div>
        {watch('isExperience') === 'Yes' ? (
          <div>
            <ExperienceTabTable isChangeFrom={isChangeFrom} setIsChangeFrom={setIsChangeFrom} isChangeTo={isChangeTo} setIsChangeTo={setIsChangeTo} activeIntershipIndex={activeIntershipIndex} setActiveIntershipIndex={setActiveIntershipIndex} enableEditProfileWithLock={props?.enableEditProfileWithLock} profileStatus={props?.profileStatus} />
            <form autoComplete="off" id="experienceForm" onSubmit={handleSubmit((e) => { handleExperienceInfoSubmit(e) })}>
              <div className="row mt-2  d-flex">
                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.1"]}&nbsp;{profileexperienceinofo.EMPLOYMENT_PRESENT_PAST}<span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.EMPLOYMENT_PRESENT_PAST}
                  </label>
                  <select className="form-select bg-color" name="typeEmploymentLookupId" value={experienceInfoState.typeEmploymentLookupId} ref={register({ required: true })} onInput={handleExperienceInfoState}>
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                    {EMPLOYMENT_TYPE.map((ele, i) => {
                      return <option key={i} value={ele.value}>{ele.label}</option>
                    })}
                  </select>
                </div>

                <div className="col-md-4  mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.2"]}&nbsp;{profileexperienceinofo.EMPLOYEE_TYPE}<span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.EMPLOYEE_TYPE}
                  </label>
                  <select className="form-select bg-color" name="employeeTypeLookupId" value={experienceInfoState.employeeTypeLookupId} ref={register({ required: true })} onInput={handleExperienceInfoState}  >
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                    {employeeTypeList && employeeTypeList.length > 0 && employeeTypeList.map((ele, i) => {
                      return <option key={i} value={ele.id}>{ele.label}</option>
                    })}
                  </select>
                </div>

                <div className="col-md-4 mb-3 pt-3" >
                  <label className="float-start">
                    {numberformat["5.3"]}&nbsp;{profileexperienceinofo.INSTITUTION_DEPARTMENT_ORGANISATION} <span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.INSTITUTION_DEPARTMENT_ORGANISATION}
                  </label>
                  <input type="text" className="form-control bg-color  text-uppercase" name="officeName" defaultValue={experienceInfoState.officeName} maxLength={500} ref={register({ required: true, pattern: expLetterNumberRegex })} onInput={(e) => { handleExperienceInfoState(e); }} onCopy={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                  />
                  {_.get("officeName.type", errors) === "required" && (
                    <p className="errorText"> {profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                  {_.get("officeName.type", errors) === "pattern" && (
                    <p className="errorText">{profileexperienceinofo.ENTER_VALID_INSTITUTE_NAME}</p>
                  )}
                </div>

                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.4"]}&nbsp;{
                      profileexperienceinofo[
                      "IS_OFFICE_INSTITUTION_OWNED_BY_GOVT_OF_BIHAR?"
                      ]
                    } <span className="redColor">*</span> {commonHILabels.EXPERIENCE_INFORMATION.IS_OFFICE_INSTITUTION_OWNED_BY_GOVT_OF_BIHAR}
                  </label>
                  <select className="form-select bg-color" name="isOfficeGovOwned" value={experienceInfoState.isOfficeGovOwned} ref={register({ required: true })} onInput={handleExperienceInfoState} >
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                    {BOOLEAN_OPTION.map((ele, i) => {
                      return <option key={i} value={ele.value}>{ele.label}</option>
                    })}
                  </select>
                  {_.get("isOfficeGovOwned.type", errors) === "required" && (
                    <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                </div>

                <div className="col-md-4" >
                  <label className="float-start w-100">
                    {numberformat["5.5"]}&nbsp;{profileexperienceinofo.DESIGNATION_POST_HELD} {commonHILabels.EXPERIENCE_INFORMATION.DESIGNATION_POST_HELD}
                    <span className="redColor">*</span>
                  </label>
                  {/* <br /> */}
                  <Select
                    className="w-100"
                    name="designationId"
                    value={
                      getJobDesignationList
                        ?.map((ele) => ({ value: ele.id, label: ele.label }))
                        .find((option) => option.value === designationId) || null
                    }
                    onChange={(selectedOption) => {
                      handleExperienceInfoState({
                        target: {
                          name: "designationId",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      });
                      setDesignationId(selectedOption ? selectedOption.value : "");
                    }}
                    options={getJobDesignationList?.map((ele) => ({
                      value: ele.id,
                      label: ele.label,
                    }))}
                    isSearchable={true} // Enables search functionality
                    placeholder={advertisementDetailsLabel.SELECT}
                  />

                  {/* <select className="form-select bg-color" name="designationId" defaultValue={experienceInfoState.designationId} value={designationId} ref={register({ pattern: expLetterNumberRegex })} onInput={(e) => { handleExperienceInfoState(e); setDesignationId(e.target.value); }}>
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>

                    {getJobDesignationList && getJobDesignationList.length > 0 && getJobDesignationList.map((ele, i) => {
                      return <option key={i} value={ele.id}>{ele.label}</option>
                    })}
                  </select> */}
                </div>

                {/* {(designationNameFlg===0 && experienceToBeEdited) && 
                <div className="col-md-4 mb-3 pt-3" >
                  <label className="float-start">
                  {numberformat["5.5.1"]}&nbsp;{profileexperienceinofo.DESIGNATION_NAME} <br/>{commonHILabels.EXPERIENCE_INFORMATION.DESIGNATION_NAME}
                  </label>
                  <input type="text" className="form-control bg-color" name="designationName"  defaultValue={experienceInfoState.designation} value={designationName} disabled></input>
                </div>
                  } */}


                <div className="col-md-4 mb-3">
                  <label className="float-start w-100">
                    {numberformat["5.6"]}&nbsp;{profileexperienceinofo.NATURE_OF_JOB} <span className="redColor">*</span> {commonHILabels.EXPERIENCE_INFORMATION.NATURE_OF_JOB}
                  </label>
                  {/* <select className="form-select bg-color" name="jobNatureLookupId" value={experienceInfoState.jobNatureLookupId} ref={register({ required: true })} onInput={handleExperienceInfoState}>
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                    {jobNatureList && jobNatureList.sort((jobNature1, jobNature2) => {
                      return jobNature1.label.trim().localeCompare(jobNature2.label.trim())
                    }).map((ele, i) =>
                      <option key={i} value={ele.id}>{ele.label}</option>
                    )}
                  </select> */}

                  <Select
                    className="w-100"
                    name="jobNatureLookupId"
                    value={
                      jobNatureList
                        ?.map((ele) => ({ value: ele.id, label: ele.label }))
                        .find((option) => option.value === experienceInfoState.jobNatureLookupId) || null
                    }
                    onChange={(selectedOption) => {
                      handleExperienceInfoState({
                        target: {
                          name: "jobNatureLookupId",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      });
                    }}
                    options={jobNatureList
                      ?.sort((a, b) => a.label.trim().localeCompare(b.label.trim()))
                      .map((ele) => ({
                        value: ele.id,
                        label: ele.label,
                      }))}
                    isSearchable={true} // Enables search functionality
                    placeholder={advertisementDetailsLabel.SELECT}
                  />
                  {_.get("jobNatureLookupId.type", errors) === "required" && (
                    <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                </div>
                {<div className="col-md-4 mb-3 mt-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.7"]}&nbsp;{profileexperienceinofo["WHETHER_THE_POST_IS_GAZETTED?"]} <span className="redColor"> {employeeTypeLookupId != commonENLabels.DATABASE_VALUES.Private_employeeTypeLookupId ? "*" : ""}</span>{commonHILabels.EXPERIENCE_INFORMATION.WHETHER_THE_POST_IS_GAZETTED}
                  </label>
                  <select className="form-select bg-color" name="isGazettedPost" value={experienceInfoState.isGazettedPost} ref={register({ required: true })} onInput={handleExperienceInfoState} >
                    <option key="" value="">
                      {advertisementDetailsLabel.SELECT}
                    </option>

                    {experienceInfoState.employeeTypeLookupId == commonENLabels.DATABASE_VALUES.Private_employeeTypeLookupId ? (
                      <option value={false}>No</option>
                    ) : (
                      BOOLEAN_OPTION.map((ele, i) => (
                        <option key={i} value={ele.value}>
                          {ele.label}
                        </option>
                      ))
                    )}
                  </select>
                  {employeeTypeLookupId != commonENLabels.DATABASE_VALUES.Private_employeeTypeLookupId && _.get("isGazettedPost.type", errors) === "required" && (
                    <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                </div>}
                {isGazettedPostflg && isGazettedPostflg == 'true' ?
                  <div className="col-md-4 mb-3  pt-3">
                    <label className="float-start">
                      {numberformat["5.7.1"]}&nbsp;{profileexperienceinofo.GROUP} <span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.GROUP}
                    </label>
                    <select className="form-select bg-color" name="typeGroupLookupId" value={experienceInfoState.typeGroupLookupId} ref={register({ required: true })} onInput={handleExperienceInfoState}>
                      <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                      {GROUP_OPTION.map((ele, i) => {
                        return <option key={i} value={ele.value}>{ele.label}</option>
                      })}
                    </select>
                    {_.get("typeGroupLookupId.type", errors) === "required" && (
                      <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                    )}
                  </div> : ''}

                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start w-100">
                    {numberformat["5.8"]}&nbsp;{profileexperienceinofo.NATURE_OF_APPOINTMENT} <span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.NATURE_OF_APPOINTMENT}
                  </label>
                  <Select
                    className="w-100"
                    name="apointmentNatureLookupId"
                    value={
                      appointmentNatureList
                        ?.map((ele) => ({ value: ele.id, label: ele.label }))
                        .find((option) => option.value === experienceInfoState.apointmentNatureLookupId) || null
                    }
                    onChange={(selectedOption) => {
                      handleExperienceInfoState({
                        target: {
                          name: "apointmentNatureLookupId",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      });
                    }}
                    options={appointmentNatureList
                      ?.sort((a, b) => a.label.localeCompare(b.label))
                      .map((ele) => ({
                        value: ele.id,
                        label: ele.label,
                      }))}
                    isSearchable={true} // Enables search functionality
                    placeholder={advertisementDetailsLabel.SELECT}
                  />

                  {/* <select className="form-select bg-color" name="apointmentNatureLookupId" value={experienceInfoState.apointmentNatureLookupId} ref={register({ required: true })} onInput={handleExperienceInfoState} >
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                    {appointmentNatureList && appointmentNatureList.sort((appointmentNature1, appointmentNature2) => { return appointmentNature1.label.localeCompare(appointmentNature2.label) }).map((ele, i) =>
                      <option key={i} value={ele.id}>{ele.label}</option>
                    )}
                  </select> */}
                  {_.get("apointmentNatureLookupId.type", errors) === "required" && (
                    <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                </div>
                {(apointmentNatureflag && apointmentNatureflag == "229") ||
                  apointmentNatureflag == "240" ||
                  apointmentNatureflag == "242" ||
                  apointmentNatureflag == "243" ? (
                  <div className="col-md-4 mb-3 pt-3">
                    <label className="float-start">
                      {numberformat["5.8.1"]}&nbsp;
                      {profileexperienceinofo.APPOINTMENT_LETTER_NO} {commonHILabels.EXPERIENCE_INFORMATION.APPOINTMENT_LETTER_NO}
                      <span className="redColor">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control bg-color  text-uppercase"
                      name="appointmentLetterNo"
                      defaultValue={experienceInfoState.appointmentLetterNo}
                      ref={register({ required: true, pattern: devNagariRegex })}
                      onInput={handleExperienceInfoState}
                    // onCopy={(e) => e.preventDefault()}
                    // onCut={(e) => e.preventDefault()}
                    // onPaste={(e) => e.preventDefault()}
                    />
                    {_.get("appointmentLetterNo.type", errors) === "required" && (
                      <p className="errorText">
                        {profileexperienceinofo.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                    {errors.appointmentLetterNo?.type === "pattern" && (
                      <p className="errorText">
                        {
                          profileexperienceinofo.ENTER_VALID_APPOINMENT_LETTER_NUMBER
                        }
                      </p>
                    )}
                  </div>
                ) : (
                  ""
                )}
                {(apointmentNatureflag && apointmentNatureflag == "229") ||
                  apointmentNatureflag == "240" ||
                  apointmentNatureflag == "242" ||
                  apointmentNatureflag == "243" ? (
                  <div className="col-md-4 mb-3 pt-3">
                    <label className="float-start">
                      {numberformat["5.8.2"]}&nbsp;{profileexperienceinofo.LETTER_DATE} <span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.LETTER_DATE}
                    </label>
                    <Controller
                      name="appointmentLetterDate"
                      key={experienceInfoState.appointmentLetterDate ? "appointmentLetterDate" : "appointmentLetterDate1"}
                      defaultValue={experienceInfoState.appointmentLetterDate ? dayjs(experienceInfoState.appointmentLetterDate).toDate() : ""}
                      rules={{ required: true }}
                      control={control}
                      render={({ onChange, value }) => (
                        <DatePicker
                          selected={fromUTCDate(value)}
                          maxDate={new Date()}
                          showIcon
                          onChange={(e) => {
                            setExperienceInfoState({
                              ...experienceInfoState,
                              appointmentLetterDate: toUTCDate(e)
                            }); onChange(toUTCDate(e))
                          }}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                          onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          className="form-control bg-color"
                        />
                      )}
                    />
                    {_.get("appointmentLetterDate.type", errors) === "required" && (
                      <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                    )}
                  </div>
                ) : (
                  ""
                )}
                {apointmentNatureflag && apointmentNatureflag == "229" ?
                  <div className="col-md-4 mb-3 pt-3">
                    <label className="float-start">
                      {numberformat["5.8.3"]}&nbsp;{profileexperienceinofo.FULL_TIME_OTHER} {commonHILabels.EXPERIENCE_INFORMATION.FULL_TIME_OTHER}
                    </label>
                    <select className="form-select bg-color" name="fullTimeLookupId" value={experienceInfoState.fullTimeLookupId} ref={register({ required: false })} onInput={handleExperienceInfoState}
                      disabled={!experienceInfoState.apointmentNatureLookupId} >
                      <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                      {FULLTIME_OPTION.map((ele, i) => {
                        return <option key={i} value={ele.value}>{ele.label}</option>
                      })}

                    </select>
                  </div> : ''}

                {apointmentNatureflag && apointmentNatureflag == "227" || apointmentNatureflag == "230" ?
                  <div className="col-md-4 mb-3 pt-3">
                    <label className="float-start">
                      {numberformat["5.8.1"]}&nbsp;{profileexperienceinofo.FULL_TIME_OTHER} {commonHILabels.EXPERIENCE_INFORMATION.FULL_TIME_OTHER}
                    </label>
                    <select className="form-select bg-color" name="fullTimeLookupId" value={experienceInfoState.fullTimeLookupId} ref={register({ required: false })} onInput={handleExperienceInfoState} >
                      <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                      {FULLTIME_OPTION.map((ele, i) => {
                        return <option key={i} value={ele.value}>{ele.label}</option>
                      })}

                    </select>
                  </div> : ''}


                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.9"]}&nbsp;{profileexperienceinofo.PAY_BAND_PAY_SCALE} {commonHILabels.EXPERIENCE_INFORMATION.PAY_BAND_PAY_SCALE}
                  </label>
                  <input type="text" className="form-control bg-color text-uppercase" maxLength={20} name="payScale" defaultValue={experienceInfoState.payScale} ref={register({ pattern: numberWithDecimal })} onInput={(e) => { handleExperienceInfoState(e); }}
                  />
                  {_.get("payScale.type", errors) === "required" && (
                    <p className="errorText"> {profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                  {_.get("payScale.type", errors) === "pattern" && (
                    <p className="errorText">{commonENLabels.VALIDATE_MESSAGE.ONLY_NUMBERS_ALLOWED} </p>
                  )}
                </div>
                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.10"]}&nbsp;{profileexperienceinofo.GRADE_PAY} {commonHILabels.EXPERIENCE_INFORMATION.GRADE_PAY}
                  </label>
                  <input type="text" className="form-control bg-color text-uppercase" maxLength={6} name="gradePay" defaultValue={experienceInfoState.gradePay} ref={register({ pattern: numberWithDecimal })} onInput={(e) => { handleExperienceInfoState(e); }}
                  />
                  {_.get("gradePay.type", errors) === "pattern" && (
                    <p className="errorText">{profileexperienceinofo.ENTER_VALID_GRADE_PAY} </p>
                  )}

                </div>
                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.11"]}&nbsp;{profileexperienceinofo.BASIC_PAY} {commonHILabels.EXPERIENCE_INFORMATION.BASIC_PAY}
                  </label>
                  <input type="text" className="form-control bg-color text-uppercase" maxLength={6} name="basicPay" defaultValue={experienceInfoState.basicPay} ref={register({ pattern: numberWithDecimal })} onInput={(e) => { handleExperienceInfoState(e); }}
                  />
                  {_.get("basicPay.type", errors) === "required" && (
                    <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}


                </div>

                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.12"]}&nbsp;{profileexperienceinofo.MONTHLY_GROSS_SALARY} {commonHILabels.EXPERIENCE_INFORMATION.MONTHLY_GROSS_SALARY}
                  </label>
                  <input type="text" className="form-control bg-color text-uppercase" maxLength={6} name="monthlyGrossSalary" defaultValue={experienceInfoState.monthlyGrossSalary} ref={register({ pattern: numberWithDecimalandComma })} onInput={(e) => { handleExperienceInfoState(e); }}
                  />
                  {_.get("monthlyGrossSalary.type", errors) === "pattern" && (
                    <p className="errorText"> {profileexperienceinofo.ENTER_VALID_MONTHIY_GROSS_SALARY}</p>
                  )}


                </div>
                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.13"]}&nbsp;{profileexperienceinofo["MEDICAL_COLLEGE_AND_INSTITUTE"]}
                    {commonHILabels.EXPERIENCE_INFORMATION.MEDICAL_COLLEGE_AND_INSTITUTE}
                    <span className="redColor">*</span>
                  </label>

                  <select className="form-select bg-color" name="institutionLookupId" value={experienceInfoState.institutionLookupId}
                    onInput={handleExperienceInfoState}
                    ref={register({ required: true })}
                  >
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                    {
                      medicalCollegesList && medicalCollegesList.length > 0 && medicalCollegesList
                        .sort((a, b) => a.sortOrder < b.sortOrder ? - 1 : 1)
                        .map((ele) =>
                          <option key={ele.id} value={ele.id}>{ele.label}</option>
                        )
                    }
                  </select>
                  {_.get("institutionLookupId.type", errors) === "required" && (
                    <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                </div>
                {/* <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.13"]}&nbsp;{profileexperienceinofo["WHETHER_SELECTED_FROM_BPSC?"]}
                    {commonHILabels.EXPERIENCE_INFORMATION.WHETHER_SELECTED_FROM_BPSC}
                  </label>

                  <select className="form-select bg-color" name="isBpscSelection" value={experienceInfoState.isBpscSelection}
                    onInput={handleExperienceInfoState}
                  >
                    <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                    {BOOLEAN_OPTION.map((ele, i) => {
                      return <option key={i} value={ele.value}>{ele.label}</option>
                    })}
                  </select>
                </div> */}
                {/* {isBpscSelectionflg && isBpscSelectionflg == 'true' ?
                  <div className="col-md-4 mb-3 pt-3">
                    <label className="float-start">
                      {numberformat["5.13.1"]}&nbsp;{profileexperienceinofo.POST_NAME} <span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.POST_NAME}
                    </label>
                    <select className="form-select bg-color" name="postNameLookupId" value={experienceInfoState.postNameLookupId} ref={register({ required: true })} onInput={handleExperienceInfoState}

                      disabled={!experienceInfoState.isBpscSelection}
                    >
                      <option key="" value="">{advertisementDetailsLabel.SELECT}</option>
                      {postList && postList.sort((postName1, postName2) => { return postName1.label.localeCompare(postName2.label) })
                        .map((ele, i) =>
                          <option key={i} value={ele.id}>{ele.label}</option>
                        )}
                    </select>
                    {_.get("postNameLookupId.type", errors) === "required" && (
                      <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                    )}
                  </div>
                  : ''}
                {
                  experienceInfoState.postNameLookupId && experienceInfoState.postNameLookupId == 444 ?
                    <div className="col-md-4 mb-3 pt-3">
                      <label className="float-start">
                        {numberformat["5.13.2"]}&nbsp;{profileexperienceinofo.POST_NAME_OTHER} <span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.POST_NAME_OTHER}
                      </label>
                      <input type="text" className="form-control bg-color text-uppercase" name="postNameOther" defaultValue={experienceInfoState.postNameOther} maxLength={100} ref={register({ required: true, pattern: expLetterNumberRegex })} onInput={handleExperienceInfoState}
                      />
                      {_.get("postNameOther.type", errors) === "required" && (
                        <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                      )}
                      {_.get("postNameOther.type", errors) === "pattern" && (
                        <p className="errorText">{profileexperienceinofo.ENTER_VALID_OTHER_POST_NAME}</p>
                      )}
                    </div>
                    : ""} */}


                <div className="col-md-4 mb-3 pt-3">
                  <label className="float-start">
                    {numberformat["5.14"]}&nbsp;{profileexperienceinofo.FROM_DATE} <span className="redColor">*</span>{commonHILabels.EXPERIENCE_INFORMATION.FROM_DATE}
                  </label>
                  <Controller
                    name="employmentFrom"
                    key={experienceInfoState.employmentFrom ? "employmentFrom" : "employmentFrom1"}
                    value={experienceInfoState.employmentFrom ? dayjs(experienceInfoState.employmentFrom).toDate() : ""}
                    defaultValue={experienceInfoState.employmentFrom ? dayjs(experienceInfoState.employmentFrom).toDate() : ""}
                    rules={{ required: true, validate: value => value <= new Date() }}
                    control={control}
                    isDisabled={!experienceInfoState.postNameLookupId}
                    render={({ onChange, value }) => (
                      <DatePicker
                        selected={isChangeFrom ? fromUTCDate(value) : fromUTCDate(experienceInfoState.employmentFrom)}
                        showIcon
                        onChange={(e) => {
                          setExperienceInfoState({
                            ...experienceInfoState,
                            employmentFrom: toUTCDate(e)
                          }); setIsChangeFrom(true); handleFromToDateSelection(toUTCDate(e), ''); setReloadItem(!reloadItem); onChange(toUTCDate(e))
                        }}
                        icon={
                          <img
                            src="/icons/calender.png"
                            className="date-picker-icon"
                          ></img>
                        }
                        onKeyDown={preventDateManualTyping}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText={commonLabels.DATE_FORMAT}
                        dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                        maxDate={watch("employmentTo") || new Date()}
                        minDate={fromUTCDate(authenticationDataObj?.dob)}
                        className="form-control bg-color"
                        disabled={!experienceInfoState.apointmentNatureLookupId}

                      />
                    )}
                  />
                  {_.get("employmentFrom.type", errors) === "required" && (
                    <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                  )}
                </div>

                {(istypeEmploymentflg == "1" && employmentFromSelected) || (istypeEmploymentflg == "1" && experienceInfoState.employmentFrom) ?
                  <div className="col-md-4 mb-3 pt-3">
                    <label className="float-start">
                      {numberformat["5.15"]}&nbsp;{profileexperienceinofo.TO_DATE} <span className="redColor">*</span> {commonHILabels.EXPERIENCE_INFORMATION.TO_DATE}
                    </label>
                    <Controller
                      name="employmentTo"
                      key={experienceInfoState.employmentTo ? "employmentTo" : "employmentTo1"}
                      value={experienceInfoState.employmentTo ? dayjs(experienceInfoState.employmentTo).toDate() : ""}
                      defaultValue={experienceInfoState.employmentTo ? dayjs(experienceInfoState.employmentTo).toDate() : ""}
                      rules={{ required: true, validate: value => value <= new Date() }}
                      control={control}
                      render={({ onChange, value }) => (
                        <DatePicker
                          selected={isChangeTo ? fromUTCDate(value) : fromUTCDate(experienceInfoState.employmentTo)}
                          maxDate={new Date()}
                          showIcon
                          onChange={(e) => {
                            setExperienceInfoState({
                              ...experienceInfoState,
                              employmentTo: toUTCDate(e)
                            }); handleFromToDateSelection('', toUTCDate(e)); onChange(toUTCDate(e)); setIsChangeTo(true); setReloadItem(!reloadItem);
                          }}
                          icon={
                            <img
                              src="/icons/calender.png"
                              className="date-picker-icon"
                            ></img>
                          }
                          onKeyDown={preventDateManualTyping}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText={commonLabels.DATE_FORMAT}
                          dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                          minDate={watch("employmentFrom") || new Date()}
                          className="form-control bg-color"
                        />
                      )}
                    />
                    {_.get("employmentTo.type", errors) === "required" && (
                      <p className="errorText">{profileexperienceinofo.MANDATORY_FIELD_MESSAGE}</p>
                    )}
                  </div> : ''}
                <div className="col-md-4 ">
                  <div className="row d-flex">
                    <div className="col-md-4 mb-3 pt-3 pe-1">
                      <label className="float-start">
                        {profileexperienceinofo.YEARS} {commonHILabels.EXPERIENCE_INFORMATION.YEARS}
                      </label>
                      <input type="text" className="form-control bg-color text-uppercase" name="expYears" defaultValue={experienceInfoState && experienceInfoState.expYears} ref={register({ required: false })} onInput={handleExperienceInfoState} disabled
                      />
                    </div>
                    <div className="col-md-4 mb-3 pt-3 pe-1">
                      <label className="float-start">
                        {profileexperienceinofo.MONTHS} {commonHILabels.EXPERIENCE_INFORMATION.MONTHS}
                      </label>
                      <input type="text" className="form-control bg-color text-uppercase" name="expMonths" defaultValue={experienceInfoState && experienceInfoState.expMonths} ref={register({ required: false })} onInput={handleExperienceInfoState} disabled
                      />
                    </div>
                    <div className="col-md-4 mb-3 pt-3 pe-1">
                      <label className="float-start">
                        {profileexperienceinofo.DAYS} {commonHILabels.EXPERIENCE_INFORMATION.DAYS}
                      </label>
                      <input type="text" className="form-control bg-color text-uppercase" name="expDays" defaultValue={experienceInfoState && experienceInfoState.expDays} ref={register({ required: false })} onInput={handleExperienceInfoState} disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row  d-flex">
           
                <div className="text-center">
                  {
                    props.profileStatus !== true ? (
                      <>
                        {
                          flagExperienceEdit
                            ?
                            <button type="submit" name="edit" className=" btn btn-primary custom_button  m-1  " onClick={() => {
                              setActionType('edit');
                              setActiveIntershipIndex("");
                            }}>{common.UPDATE}</button>
                            :
                            flagExperienceEdit || istypeEmploymentflg ?
                            <>
                             test <button type="submit" name="add" className=" btn btn-primary custom_button  m-1" onClick={() => { setActionType('add') }}>{common.ADD}</button>
                            </>
                              : ""
                        }
                      </>
                    ) : (
                      props.enableEditProfileWithLock?.editProfileWithLock == "1" ? (
                        (() => {
                          const experienceInfoList = props.enableEditProfileWithLock?.ExperienceInfo?.split(",") || [];
                          const canCreate = experienceInfoList.includes("C");
                          const canUpdate = experienceInfoList.includes("U");

                          if (flagExperienceEdit && canUpdate) {
                            return (
                              <button
                                type="submit"
                                name="edit"
                                className="btn btn-primary custom_button m-1"
                                onClick={() => {
                                  setActionType("edit");
                                  setActiveIntershipIndex("");
                                }}
                              >
                                {common.UPDATE}
                              </button>
                            );
                          } else if ((flagExperienceEdit || istypeEmploymentflg) && canCreate) {
                            return (
                              <>
                              <button
                                type="submit"
                                name="add"
                                className="btn btn-primary custom_button m-1"
                                onClick={() => setActionType("add")}
                              >
                                {common.ADD}
                              </button>
                              </>
                            );
                          } 
                        })()
                      ) : ""
                    )
                  }

                  {/* {
                    flagExperienceEdit
                      ?
                      <button type="submit" name="edit" className=" btn btn-primary custom_button  m-1  " onClick={() => {
                        setActionType('edit');
                        setActiveIntershipIndex("");
                      }}>{common.UPDATE}</button>
                      :
                      flagExperienceEdit || istypeEmploymentflg ?
                        <button type="submit" name="add" className=" btn btn-primary custom_button  m-1" onClick={() => { setActionType('add') }}>{common.ADD}</button>
                        : ""
                  } */}
                </div>
                <p className="paraCss"></p>
                <div className="text-center">
                  
                  {
                    props.profileStatus !== true ? (
                      <button
                        type="button"
                        className="btn btn-primary custom_button m-1"
                        onClick={() => setShowModal(true)}
                        disabled={isDisableAllTabSave}
                      >
                        {common.SAVE}
                      </button>
                    ) : (
                      props.enableEditProfileWithLock?.editProfileWithLock == "1" && (() => {
                        const experienceInfoList = props.enableEditProfileWithLock?.ExperienceInfo?.split(",") || [];
                        const hasCreate = experienceInfoList.includes("C");
                        const hasUpdate = experienceInfoList.includes("U");
                        const hasDelete = experienceInfoList.includes("D");
                        const hasReadOnly = experienceInfoList.includes("R");

                        if (hasCreate || hasUpdate || hasDelete) {
                          return (
                            <button
                              type="button"
                              className="btn btn-primary custom_button m-1"
                              onClick={() => setShowModal(true)}
                              disabled={isDisableAllTabSave}
                            >
                              {common.SAVE}
                            </button>
                          );
                        } else if (hasReadOnly) {
                          return (
                            <span className="profile_disable_button">
                              {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                            </span>
                          );
                        } 
                      })()
                    )
                  }


                  {/* <button type="button" className=" btn btn-primary custom_button  m-1" onClick={() => { setShowModal(true) }} disabled={isDisableAllTabSave} >{common.SAVE}</button> */}
                </div>
              </div>
              <Modal show={showModal} onHide={() => { setShowModal(false) }} backdrop='static'>
                <Modal.Header className="custom-modal-header logout_heading">
                  <Modal.Title className='logout_title'>{profileexperienceinofo.SAVE_EXPERIENCE_MODAL_TITLE}</Modal.Title>
                  <button
                    type="button"
                    className="ms-auto logout_close"
                    aria-label="Close"
                    onClick={() => { setShowModal(false) }}
                  >X</button>
                </Modal.Header>
                <Modal.Body>
                  <label>{profileexperienceinofo.SAVE_EXPERIENCE_CONFIRMATION_MESSAGE}</label>
                </Modal.Body>
                <Modal.Footer>
                  <button className="btn btn-secondary" onClick={() => { setShowModal(false) }}>{common.CANCEL}</button>
                  <button className=" btn btn-primary custom_button   " onClick={modalConfirm}>{common.CONFIRM}</button>
                </Modal.Footer>
              </Modal>
            </form>

          </div >
        ) : (
          <div className="row  d-flex">
            <div className="text-center">
              <button type="button" className=" btn btn-primary custom_button  m-1" onClick={saveExpInfo} disabled={isDisableAllTabSave}>{common.SAVE}</button>
            </div>
          </div>
        )
        }
      </div >
    );
}

export default ExperienceInformation;